import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionDescriptionService {

  constructor(private httpClientService:HttpClientService) { }
  
  async getAllTransactionDescriptionList(page,size){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.TransactionManagementDescription,
      action:"GetAlTransactionManagementDescription",
      queryString:`Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async getAllTransactionDescriptions(){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.TransactionManagementDescription,
    });
    return await firstValueFrom(observable);
  }

  async getByIdTransactionDescription(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.TransactionManagementDescription,
    },id);
    return await firstValueFrom(observable);
  }

  async createTransactionDescription(title,description){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.TransactionManagementDescription,
    },{
      title:title,
      description:description
    });
    return await firstValueFrom(observable);
  }

  async updateTransactionDescription(id,title,description){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.TransactionManagementDescription,
    },{
      id:id,
      title:title,
      description:description
    });
    return await firstValueFrom(observable);
  }

}
